<script lang="ts" setup>
    import AppForm from '@/pages/core/form/AppForm.vue';
    import { useUserStore } from '@/stores/user';
    import { useTheme } from 'vuetify';
    import { Platform } from '@/constants';
    import { userService } from '@/services/userService';
    import { getPlatform } from '@/helpers/getPlatform';

    const userStore = useUserStore();
    const theme = useTheme();
    const changeSettingsForm = ref<any>(null);
    const { t } = useI18n();

    const changeSettings = (): void => {
        userService.changeSettings(userStore.settings);
    };

    onMounted((): void => {
        console.log('Component app-menuAccountChangeSettings mounted.');
    });
</script>
<template>
    <AppForm class="pl-3 pr-3" v-if="userStore.settings" ref="changeSettingsForm">
        <v-card-title v-if="getPlatform() === Platform.Tradeball" class="pt-2 pl-3 pb-0">
            <span :class="theme.name.value === 'dark' ? 'lightGreyText' : 'lightBlackText'" class="font-weight-regular font16">
                {{ t('menu.settings') }}
            </span>
        </v-card-title>
        <v-card-text v-if="getPlatform() === Platform.Tradeball">
            <v-container class="pl-0 pr-0 py-0 text-center">
                <v-row dense>
                    <v-col cols="6" class="px-2 pt-0 pb-0" style="height: 32px">
                        <v-switch
                            color="tbGreen"
                            class="mt-1"
                            v-model="userStore.settings.is_show_credit"
                            :false-value="0"
                            :true-value="1"
                            :label="t('menu.showCredit')"
                            :hide-details="true"
                            :ripple="false"
                            @change="changeSettings"
                            density="compact"
                        ></v-switch>
                    </v-col>
                    <v-col cols="6" class="px-2 pt-0 pb-0" style="height: 32px">
                        <v-switch
                            color="tbGreen"
                            class="mt-1"
                            v-model="userStore.settings.is_show_balance"
                            :false-value="0"
                            :true-value="1"
                            :label="t('menu.showBalance')"
                            :hide-details="true"
                            :ripple="false"
                            @change="changeSettings"
                            density="compact"
                        ></v-switch>
                    </v-col>
                    <v-col cols="12" class="px-2 pt-0 pb-0" style="height: 32px">
                        <v-switch
                            color="tbGreen"
                            class="mt-3"
                            v-model="userStore.settings.is_show_exposure"
                            :false-value="0"
                            :true-value="1"
                            :label="t('menu.showExposure')"
                            :hide-details="true"
                            :ripple="false"
                            @change="changeSettings"
                            density="compact"
                        ></v-switch>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-title class="pt-2 pl-3 pb-0">
            <span :class="theme.name.value === 'dark' ? 'lightGreyText' : 'lightBlackText'" class="font-weight-regular font16">
                {{ t('menu.betNotifications') }}
            </span>
        </v-card-title>
        <v-card-text>
            <v-container class="pa-0 text-center">
                <v-row dense>
                    <v-col cols="6" class="px-2 pt-0 pb-0">
                        <v-switch
                            color="tbGreen"
                            class="mt-1"
                            v-model="userStore.settings.is_play_sound_on_bet"
                            :false-value="0"
                            :true-value="1"
                            :label="t('menu.playSoundOnBet')"
                            :hide-details="true"
                            :ripple="false"
                            @change="changeSettings"
                            density="compact"
                        ></v-switch>
                    </v-col>
                    <v-col cols="6" class="px-2 pt-0 pb-0">
                        <v-switch
                            color="tbGreen"
                            class="mt-1"
                            v-model="userStore.settings.is_show_popup_on_bet"
                            :false-value="0"
                            :true-value="1"
                            :label="t('menu.showPopUpOnBet')"
                            :hide-details="true"
                            :ripple="false"
                            @change="changeSettings"
                            density="compact"
                        ></v-switch>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </AppForm>
</template>
<style scoped></style>
